'use client'

import useCartStore, { ICartItem } from '@/store/cartStore'
import useCommonStore from '@/store/commonStore'
import { X } from 'lucide-react'
import { useState, useEffect, useRef } from 'react'
import AddQuantity from "@/components/common/AddQuantity";


interface IObj {
    [key: string]: any
}

export function VariantPopup({ open, onClose, variants, handler,mxq }: { open: boolean, onClose: () => void, variants: IObj[], handler: (item: ICartItem, mxq?: number, type?: string, spl_prc?: number, pdt_nm?: string) => Promise<void>, mxq: number }) {
    const [show, setShow] = useState(open)
    const [loading, setLoading] = useState(false)
    const modalRef = useRef<HTMLDivElement>(null)
    const [selectedVariant, setSelectedVariant] = useState<IObj | null>(null)
    const { cart,updateCart } = useCartStore()
    const { isAuth,translations } = useCommonStore()

    useEffect(() => {
        if (open) {
            setShow(true)
            if(!selectedVariant) setSelectedVariant(variants[0])
        } else {
            const timeout = setTimeout(() => setShow(false), 300)
            return () => clearTimeout(timeout)
        }
        return () => { setSelectedVariant(null) }
    }, [open])

    // Close on outside click
    // useEffect(() => {
    //     if (!open) return
    //     function handleClick(e: MouseEvent) {
    //         if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
    //             onClose()
    //         }
    //     }
    //     document.addEventListener('mousedown', handleClick)
    //     return () => document.removeEventListener('mousedown', handleClick)
    // }, [open, onClose])

    if (!show) return null



    return (
        <div className={`fixed inset-0 bg-black/40 flex items-end md:items-center justify-center transition-opacity duration-300 z-[51] ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} style={{ zIndex: 99 }}>
            <div
                ref={modalRef}
                className={`bg-white w-full max-w-md rounded-t-2xl md:rounded-2xl p-4 shadow-lg relative transition-transform duration-300
        ${open ? 'translate-y-0 md:scale-100' : 'translate-y-full md:scale-95'}`}
            >
                <button
                    className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 rtl:left-4 rtl:right-auto"
                    onClick={onClose}
                >
                    <X className="w-6 h-6" />
                </button>
                <div className="font-semibold text-lg mb-5">{translations?.["slct_vrnt"]||"Select a variant"}</div>
                {
                    variants?.length > 0 ? (
                        <div className="overflow-x-auto scrollbar-hide flex">
                            {
                                variants?.map((v: IObj, i: number) => (
                                    <div key={v.variant_id} onClick={() => setSelectedVariant(v)} className={`${i == 0 ? 'pr-3' : 'px-3'}`}>
                                        <div className={` flex-1 rounded-md px-3  py-2 w-[180px] bg-chart-1 border border-chart-2 cursor-pointer flex justify-center`}>
                                            <img src={v?.thumbnail || v?.image?.[0]} className='h-40 object-contain' alt="" />
                                        </div>
                                        <div className="flex flex-wrap gap-2 mt-3">
                                            {v.size && <p className='bg-[#FFF1E4] rounded-md text-xs p-2 font-bold align-center text-center text-[#6D401A]'>{v.size}</p>}
                                            {v.color_nm && <p className='bg-[#FFF1E4] rounded-md text-xs p-2 font-bold align-center text-center text-[#6D401A]'>{v.color_nm}</p>}
                                            {v.flavor_nm && <p className='bg-[#FFF1E4] rounded-md text-xs p-2 font-bold align-center text-center text-[#6D401A]'>{v.flavor_nm}</p>}
                                        </div>
                                        {/* <div className="mt-3 bg-[#FFF1E4] rounded-md text-xs p-2 font-bold align-center text-center text-[#6D401A]">
                                            {v.size && <p>Size : {v.size}</p>}
                                        </div>
                                        <div className="mt-3 bg-[#FFF1E4] rounded-md text-xs p-2 font-bold align-center text-center text-[#6D401A]">
                                            {!v.color_nm && <p>Color : {v.color_nm}</p>}
                                        </div>
                                        <div className="mt-3 bg-[#FFF1E4] rounded-md text-xs p-2 font-bold align-center text-center text-[#6D401A]">
                                            {!v.flavor_nm && <p>Flavor : {v.flavor_nm}</p>}
                                        </div> */}
                                        <div className='flex items-center gap-2 mt-3 mb-1'>
                                            <p className="text-xs font-bold text-[#01DB80]">{v.disc} {translations?.["off"]||"OFF"}</p>
                                            <div className="border-dashed border-b flex-1"></div>
                                        </div>
                                        <div className="flex gap-2 justify-between items-center">
                                            <div className="flex flex-col items-center mt-1">
                                                <span className="font-bold">{v.spl_prc}</span>
                                                <span className="font-bold text-xs text-gray-400 line-through">{v.price}</span>
                                            </div>
                                            {
                                                v.in_stk ? (
                                                    <AddQuantity
                                                        quantity={cart.find(item => item.variant_id === v.variant_id)?.quantity || 0}
                                                        onAdd={() => handler({ pdt_id: v.pdt_id, variant_id: v.variant_id, quantity: (cart.find(item => item.variant_id === v.variant_id)?.quantity || 0) + 1 }, mxq, "increment",v.spl_prc_in_num,v.pdt_nm)}
                                                        onRemove={() => handler({ pdt_id: v.pdt_id, variant_id: v.variant_id, quantity: (cart.find(item => item.variant_id === v.variant_id)?.quantity || 0) - 1 }, mxq, "decrease",v.spl_prc_in_num,v.pdt_nm)}
                                                        disabled={!v.variant_id}
                                                    />
                                                ) : (
                                                    <span className="bg-red-200 p-2 py-1.5 rounded-lg text-sm font-bold text-red-700">{translations?.["out_of_stock"]||"Out of Stock"}</span>
                                                )
                                            }
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    ) : (
                        <div className='w-full h-[100px] flex items-center justify-center'>
                            <p>{translations?.["no_vnrt_avail"]||"No variants available"}</p>
                        </div>
                    )
                }
            </div>
        </div>
    )
}